import register from '../../../../global/js/registry';
export default register('m-article-index-nav', () => import(/* webpackMode: "lazy" */ './m-article-index-nav.controller'));
